const BASE_URL = "https://amiapp.dpdc.org.bd";
const OAUTH_BASE_URL = BASE_URL + "/auth/";
const ADMIN_BASE_URL = BASE_URL + "/admin/";
const COMMUNICATION_BASE_URL = BASE_URL + "/communication/";
const LOGIN_APP_URL = BASE_URL + "/login/";
const ASSEST_MANAGER_URL = BASE_URL + "/assets";
const ROCKET_CHAT_WIDGET = BASE_URL + "/assets/mitr/";
const USAGE_SERVICE_ENDPOINT = BASE_URL + "/usage/";
const BASE_TENANT_CODE = "DPDC";
const TENANT_MAP_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.1939778010556!2d78.37885331418846!3d17.450427405578676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93dce9d6cf77%3A0xe7f33917f8ba3f89!2sAbjayon%20Consulting!5e0!3m2!1sen!2sin!4v1581938464709!5m2!1sen!2sin";
const ADMIN_SERVICE_BASE_URL = BASE_URL + "/admin/admin-service";
const USAGE_SERVICE_BASE_URL = BASE_URL + "/usage/usage-service";
const COMMUNICATION_SERVICE_BASE_URL = BASE_URL + "/communication/communication-service";
const SW_VAP_PUBLIC_KEY = "BIqzBCFJaTV9Qqp7L5R0D0MeNNbqg8oMZqNzdNjnDhbeMEHw9odmqyDjZruVIUxDMP7BKvO6E2DsrYeYG-YwL6w";
const constants = {
  urls: {
    SEARCH: ADMIN_BASE_URL+"globalsearch",
    MAP_URL: TENANT_MAP_URL,
    ROCKET_CHAT_WIDGET,
    LOGIN: OAUTH_BASE_URL + "login",
    DELETE_ACCOUNT:OAUTH_BASE_URL +"login/deleteAccount",
    USAGE_ELECTRICITY_DATA: USAGE_SERVICE_ENDPOINT + "usage-comparison",
    LANGUAGE_LIST: "https://api.myjson.com/bins/1fj62q",
    LOGIN_APP: LOGIN_APP_URL ,
    LABELS: ADMIN_BASE_URL + "labels/" + BASE_TENANT_CODE,
    PARAMETER_WIDGET_CONTROL:
    ADMIN_BASE_URL + "parameter-controller/" + BASE_TENANT_CODE,
    ASSEST_CODE_API: ADMIN_BASE_URL + "assets/" + BASE_TENANT_CODE,
    PROFILE_DETAILS_DATA: ADMIN_BASE_URL + "profile-details",
    ASSEST_URL_ENDPOINT: ASSEST_MANAGER_URL,
    ADMIN_BASE_URL,
    USAGE_SERVICE_ENDPOINT,
    EXPIRE_SESSION: OAUTH_BASE_URL + "login/signout",
    REFRESH_BEARER: OAUTH_BASE_URL + "login/refresh",
    AUTH_SERVICE: OAUTH_BASE_URL + "auth-service",
    UPDATE_PASSWORD: OAUTH_BASE_URL + "login/update-password",
    ACCOUNT_SUMMARY_USAGE_GRAPH:
      USAGE_SERVICE_ENDPOINT + "usage-account-dashboard",
    ACCOUNT_SUMMARY_USAGE: USAGE_SERVICE_ENDPOINT + "account-summary-usage",
    ADMIN_SERVICE_BASE_URL: ADMIN_SERVICE_BASE_URL,
    USAGE_SERVICE_BASE_URL: USAGE_SERVICE_BASE_URL,
    OAUTH_SERVICE_BASE_URL : OAUTH_BASE_URL + "auth-service",
    LOGIN_RESENDOTP: OAUTH_BASE_URL + "otp/resend",
    VALIDATEOTP: OAUTH_BASE_URL + "otp/validate",
    COMMUNICATION_SERVICE_BASE_URL:COMMUNICATION_SERVICE_BASE_URL,
    GENERATE_BEARER_ACCESS: OAUTH_BASE_URL + "login/generate-bearer-from-access",
    ACCESS_GRANT_URL:BASE_URL+'//auth/login/tenant/grant',
    ACCESS_REVOKE_URL:BASE_URL+'//auth/login/tenant/revoke',
    LATEST_TENANT_MOBILE:BASE_URL+'//auth/login/tenant/info',
    SAVE_PUSH_SUBSCRIPTION: COMMUNICATION_BASE_URL + 'pushNotification/saveToken',
    REMOVE_PUSH_SUBSCRIPTION: COMMUNICATION_BASE_URL + 'pushNotification/removeToken',
  },
  constants: {
    BASE_TENANT_CODE: BASE_TENANT_CODE,
    BASE_URL:BASE_URL,
    I18_CACHE_EXPIRY_TIME: 60000,
    SERVICE_WORKER_VALUE_CACHE_VALUE: "SERVICE_WORKER_VALUE_CACHE_VARIABLE",
    UPDATE_ACCOUNT_DETAILS_TTL:"600000",
    ACCOUNT_DETAILS_DEFAULT_TTL:1000*60*30,
    REDIRECT_URL:"/nativeRedirect",
    NATIVEAPP_URL:"impressacx://"
  },
  NodeVariables: {
    NODE_ENV: 'production',
    PUBLIC_URL: BASE_URL,
  },
  snackBarConfig : {
    TIME_OUT: 3000,
    MAX_COUNT: 3
    },
  confidentialClient:{
    SW_VAP_PUBLIC_KEY
  },
  pagination: {
    perPage: 6
  },
  EnergyConsumption: {
    FALLBACK_MONTHLY_CHART_DATE_FORMAT: "MMM'YY"
  },
  BKASH_PAYMENT_PRECHARGE_API_SUCCESS_RESULT_CODE: "99933" 
};
export const config = constants;